module.exports = __webpack_public_path__ + "static/media/builtinv2-vse-o-shtroborezah-4.6bd4193c.png";